import SubVisual from '@/components/SubVisual';
import { useNotice } from '@/pages/customer-support/notice/hook/useNotice';

const NoticePage = () => {
	useNotice();

	return (
		<main id="sub" className="sub notice">
			<SubVisual cate={''} title={'공지사항'} />
			<section id="" className="sub-content">
				<div className="sub-inner">
					<div className="board-wrap">
						<ul
							className="board-list"
							data-template={`
							<li>
								<span class="num"></span>
									<p class="title"></p>
								<span class="date"></span>
							</li>
							`}></ul>
						<div className="board-pagination" data-template={`<button class="pagination-btn"></button>`}>
							<button className="pagination-btn btn-prev"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn btn-next"></button>
						</div>
					</div>
				</div>
			</section>
		</main>
	);
};

export default NoticePage;
